<template>
  <div>
    <close-button @click="$emit('close')" class="close-button"></close-button>

    <div class="dialog-content">
      <material-overview class="materials"></material-overview>
    </div>
  </div>
</template>
<script>
import MaterialOverview from '../components/MaterialOverview.vue'

export default {
  props: {},
  data() {
    return {}
  },
  components: {
    MaterialOverview
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 40px !important;
}

.materials {
  margin-bottom: -20px;
}
</style>
